module.exports = __webpack_public_path__ + "static/media/ng07.b8e9e762.webp";